import { EyeStroke, FileMultipleStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onAddClick?: () => void;
  onRefreshClick?: () => void;
  onPintClick?: () => void;
  onEditClick?: () => void;
  onExportDataClick?: () => void;
  onEditPrintTemplateClick?: () => void;
  onViewClick?: () => void;
  onDeleteClick?: () => void;
  onCopyClick?: () => void;
  className?: string;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onAddClick,
  onRefreshClick,
  onPintClick,
  onEditClick,
  onExportDataClick,
  onEditPrintTemplateClick,
  onViewClick,
  onDeleteClick,
  onCopyClick,
  className
}) => {
  return (
    <ActionBarV2 className={className} title='Cập nhật điều kiện thanh toán'>
      {onAddClick && <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} />}
      {onEditClick && <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} variant='secondary' />}
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} variant='secondary' />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyClick} variant='secondary' />
      <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} variant='secondary' />

      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: () => onRefreshClick,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            group: 0,
            onClick: () => onPintClick
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={18} />,
            group: 1,
            onClick: () => onExportDataClick
          }
        ]}
      />
    </ActionBarV2>
  );
};
